module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IItem {
        id: string;
        displayName: string;
    }

    interface ISingleMoverAlertJson extends IAlertJSON {
        [key: string]: any;
    }

    class MeevoAlertManagerServiceMoverConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data: IServiceMoverData;

        public selectedItems: IItem[];
        public allServices: boolean = true;

        get dataForReview() {
            return this.allServices ? [this.$translate.instant('LABEL_ALL_SERVICES')] : (this.selectedItems || []).map(item => item.displayName);
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: (this.selectedItems || []).map(item => item.id),
                [this.data.allConfigKey]: this.allServices,
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: ng.translate.ITranslateService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: ISingleMoverAlertJson): void {
            this.selectedItems = alertJSON[this.data.configKey].map(itemId => (<IItem>{id: itemId}));
            if (this.selectedItems.length > 0) {
                this.allServices = false;
            }
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAlertManagerServiceMoverConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/single-service-mover-config/single-service-mover-config.component.html',
            controller: MeevoAlertManagerServiceMoverConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
